import React, { FunctionComponent } from 'react';
import {
  FormGroup, Label, Col, Input,
} from 'reactstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import 'react-phone-input-2/lib/style.css';
import { IDomainContact } from '../../store/domainCheckout/types';
import { validateContact } from 'helpers/domains/domains';

type TOwnProps = {
  contact: IDomainContact;
  contactEdited: IDomainContact;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => any;
  handleCountrySelect: (value: string) => any;
  handleCountySelect: (value: string) => any;
  errors: string[] | object;
  setErrors?: (errors: object) => any;
};
const DomainContact: FunctionComponent<TOwnProps> = ({
  contactEdited, errors, handleInput, handleCountrySelect, handleCountySelect, setErrors,
}) => {

  const fields = [
    { field: 'firstName', name: 'First Name' },
    { field: 'lastName', name: 'Last Name' },
    { field: 'email', name: 'Email' },
    { field: 'company', name: 'Company' },
    { field: 'addressLine1', name: 'Address Line 1' },
    { field: 'addressLine2', name: 'Address Line 2' },
    { field: 'city', name: 'City' },
    { field: 'county', name: 'County' },
    { field: 'country', name: 'Country' },
    { field: 'postcode', name: 'Postcode' },
    { field: 'phone', name: 'Phone' },
  ];

  const handleInputWithValidation = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Call the original handleInput
    handleInput(event);
    
    // Validate the updated contact data
    if (setErrors) {
      const updatedContact = { ...contactEdited, [event.target.id]: event.target.value };
      const validationErrors = validateContact(updatedContact);
      setErrors(validationErrors);
    }
  };

  const handleCountrySelectWithValidation = (value: string) => {
    // Call the original handleCountrySelect
    handleCountrySelect(value);
    
    // Validate the updated contact data
    if (setErrors) {
      const updatedContact = { ...contactEdited, country: value };
      const validationErrors = validateContact(updatedContact);
      setErrors(validationErrors);
    }
  };

  const handleCountySelectWithValidation = (value: string) => {
    // Call the original handleCountySelect
    handleCountySelect(value);
    
    // Validate the updated contact data
    if (setErrors) {
      const updatedContact = { ...contactEdited, county: value };
      const validationErrors = validateContact(updatedContact);
      setErrors(validationErrors);
    }
  };

  return (
    <>
      {fields.map((field, index) => {

        if (field.field === 'country') {

          return (
            <FormGroup row key={field.field + index}>
              <Col md="4">
                <Label className="text-secondary col-form-label"><strong>{field.name}</strong></Label>
              </Col>
              <Col md="8">
                <CountryDropdown
                  valueType="short"
                  priorityOptions={['GB']}
                  value={contactEdited.country ? contactEdited.country : 'GB'}
                  classes={`form-control ${errors[field.field] ? 'is-invalid' : ''}`}
                  onChange={handleCountrySelectWithValidation}
                />
                {errors[field.field]
                                && (
                                <div className="invalid-feedback">
                                  Please provide a valid
                                  {' '}
                                  {field.name}
                                </div>
                                )}
              </Col>
            </FormGroup>
          );
        
        }
        if (field.field === 'county') {

          return (
            <FormGroup row key={field.field + index + errors[field.field]}>
              <Col md="4">
                <Label className="text-secondary col-form-label"><strong>{field.name}</strong></Label>
              </Col>
              <Col md="8">
                <RegionDropdown
                  key={`${errors[field.field]}`}
                  value={contactEdited.county ? contactEdited.county : ''}
                  country={contactEdited.country ? contactEdited.country : 'GB'}
                  classes={`form-control ${errors[field.field] ? 'is-invalid' : ''}`}
                  onChange={handleCountySelectWithValidation}
                  countryValueType="short"
                />
                {errors[field.field]
                                && (
                                <div className="invalid-feedback">
                                  Please provide a valid
                                  {' '}
                                  {field.name}
                                </div>
                                )}
              </Col>
            </FormGroup>
          );
        
        }
        return (
          <FormGroup row key={field.field + index}>
            <Col md="4">
              <Label
                className="text-secondary col-form-label"
              >
                <strong>{field.name}</strong>
              </Label>
            </Col>
            <Col md="8">
              <>
                {' '}
                <Input
                  className={`form-control ${errors[field.field] ? 'is-invalid' : ''}`}
                  id={field.field}
                  value={contactEdited[field.field] ? contactEdited[field.field] : ''}
                  onChange={handleInputWithValidation}
                />
                {field.field === 'phone' && <p>Phone must start with '+' followed by country code followed by '.' followed by the remaining digits </p>}
                {errors[field.field] && (
                <div className="invalid-feedback">
                  Please provide a valid
                  {' '}
                  {field.name}
                </div>
                )}
              </>

            </Col>
          </FormGroup>
        );
      
      })}
    </>
  );

};
export default DomainContact;
